// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as SmsTemplateListApiModel from "../api-model/SmsTemplateListApiModel.bs.js";

function apiModelToState(res) {
  return List.map((function (reasonData) {
                return {
                        template_title: reasonData.template_title,
                        template_id: reasonData.template_id,
                        template_message: reasonData.template_message
                      };
              }), res.templates);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(SmsTemplateListApiModel.t_decode(json), "SmsTemplateListEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
